import React from "react";

import R from "ramda";

import { Field } from "formik";
import { Flex, Label, Input } from "src/components";

const getInputProps = R.pick([
  "id",
  "name",
  "onBlur",
  "onChange",
  "onFocus",
  "onBlur",
  "value",
]);

const CheckboxInput = ({ displayProps, error, label, ...props }) => {
  return (
    <Flex flex="1 1 auto" flexDirection="column" mb={2} {...displayProps}>
      <Flex align="center" style={{ position: "relative" }}>
        <Label flexDirection="row" align="center" fontWeight="semibold">
          <Field
            name={props.name}
            render={({ field }) => (
              <Input
                {...getInputProps(props)}
                type="checkbox"
                mt={0}
                mb={0}
                mr={1}
                checked={!!field.value}
              />
            )}
          />
          {label}
        </Label>
      </Flex>
    </Flex>
  );
};

export default CheckboxInput;



// WEBPACK FOOTER //
// ./src/components/Form/CheckboxInput.js